// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5730) return "static/chunks/44530001-2639a0d2550a84d8.js";
	if (chunkId === 9686) return "static/chunks/9686-97792873ebde3ce5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"218":"a4d391d03f42d2e2","3524":"02d9a64759bff447","6644":"6dde89d8a426887d","8436":"cab94b59cca0a8ff","9349":"a46a4b7c7f78f7c7"}[chunkId] + ".js";
};